<template>
  <div class="searchBox-minicart-content">
    <div class="searchBox-cart" @click="goGoodsCar()">
      <img :src="'icon_head_car.png' | imagePath" />
      购物车
      <span>{{ total }}</span>
    </div>
    <div class="searchBox-minicart" v-if="cartList.length">
      <ul class="searchBox-minicart-list">
        <template v-for="(item, index) in cartList">
          <li class="searchBox-minicart-item" v-if="index < 3" :key="index">
            <dl>
              <dt class="searchBox-minicart-add-datetime">
                <button
                  type="button"
                  class="btnRemove"
                  @click="removeGoods($event, index)"
                >
                  移除
                </button>
              </dt>
              <dd class="searchBox-minicart-goods-item">
                <a :href="`goodsDetail?goods_id=${item.goods_id}`">
                  <img
                    class="searchBox-minicart-goods-pic"
                    :src="item.thumbnail"
                    alt=""
                    :title="item.title"
                  />
                </a>
                <div class="searchBox-minicart-goods-main">
                  <a
                    :href="`goodsDetail?goods_id=${item.goods_id}`"
                    class="searchBox-minicart-goods-name"
                    :title="item.title"
                    >{{ item.title }}</a
                  >
                  <p class="searchBox-minicart-goods-info">
                    <span class="searchBox-minicart-goods-nums">
                      * {{ item.num }} 件
                    </span>
                    <span class="searchBox-minicart-goods-price">
                      <em>￥</em>{{ item.price }}
                    </span>
                  </p>
                </div>
              </dd>
            </dl>
          </li>
        </template>
      </ul>
      <div class="searchBox-minicart-opt">
        <span class="searchBox-minicart-total"
          >已选<em>{{ total }}</em
          >件，共计<em>{{ totalPrice }}</em></span
        >
        <button class="btn btn-danger" @click="goGoodsCar()">
          去购物车结算
        </button>
      </div>
    </div>
    <div class="searchBox-minicart-empty" v-if="!cartList.length">
      亲，购物车中没有商品哟~
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("cart", ["total", "cartList"]),
    totalPrice() {
      //购物车价格总计
      const { cartList } = this;
      let t = cartList.reduce((prev, curr) => {
        return curr.num * curr.price + prev;
      }, 0);
      return t > 0 ? this.cutZero(t.toFixed(4)) : t;
    },
  },
  methods: {
    // 购物车跳转
    goGoodsCar() {
      this.$.router.push("goodsCar");
      // if(!this.$.user.userLogin()){
      //   this.$.router.push('/login',{fromUrl:'goodsCar'})
      // } else {
      //   this.$.router.push('goodsCar')
      // }
    },
    getCartList(){
      this.$store.dispatch("cart/GetCartList");
    },
    removeGoods(e, index) {
      //移除商品
      const { cartList } = this;
      this.$store
        .dispatch("cart/RemoveCart", {
          cart_ids: JSON.stringify([cartList[index].cart_id]),
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("删除购物车商品成功!");
          }
        });
    },
    // 去小数点
    cutZero(num) {
      var pNum = num.split('.')[0]
      num = num.split('.')[1]
      if(parseInt(num)%10 == 0){
        if(parseInt(num)%100 == 0){
          if(parseInt(num)%1000 == 0){
            num = num.slice(0,num.length-3)
          } else {
            num = num.slice(0,num.length-2)
          }
        } else {
          num = num.slice(0,num.length-1)
        }
      }
      num = pNum + '.' + num
      return num
      console.log(parseFloat(num))
    }
  },
  mounted() {
    if(this.$.user.userToken()){
      this.getCartList()
    }
  },
};
</script>
<style scoped>
.searchBox-cart {
  display: flex;
  height: 38px;
  align-items: center;
  margin-top: 0;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(35, 24, 21, 0.19);
  padding: 0 12px;
  min-width: 120px;
  align-items: center;
  color: #333333;
  font-size: 14px;
  cursor: pointer;
}
.searchBox-cart img {
  width: 24px;
  height: 19px;
  margin-right: 7px;
}
.searchBox-cart span {
  background-color: #e60012;
  color: #ffffff;
  border-radius: 17px;
  min-width: 17px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  margin-left: 10px;
  font-size: 12px;
  padding: 0 5px;
}
.searchBox-cart:hover + .searchBox-minicart,
.searchBox-minicart:hover,
.searchBox-cart:hover + .searchBox-minicart-empty,
.searchBox-minicart-empty:hover {
  display: block;
}
.searchBox-minicart,
.searchBox-minicart-empty {
  position: absolute;
  top: 40px;
  right: 0;
  background: #ebeef5;
  box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
  z-index: 999;
  width: 340px;
  display: none;
  min-height: 1px;
}
.searchBox-minicart-empty {
  padding: 20px;
}
.searchBox-minicart-item {
  background: #fff;
  margin: 10px;
  cursor: pointer;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border: 1px solid #eee;
}
.searchBox-minicart-add-datetime {
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
  color: #666;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 17px;
}
.searchBox-minicart-goods-item {
  display: flex;
  padding: 10px 15px;
}
.searchBox-minicart-goods-pic {
  width: 50px;
  height: 50px;
}
.searchBox-minicart-goods-main {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
}
.searchBox-minicart-goods-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.searchBox-minicart-goods-name {
  margin-bottom: 5px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #333;
}
.searchBox-minicart-add-datetime .btnRemove {
  margin-left: auto;
  color: #e60012;
  display: none;
  height: 16px;
}
.searchBox-minicart-item:hover .btnRemove {
  display: block;
}
.searchBox-minicart-opt {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 10px;
  flex-direction: column;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.searchBox-minicart-total {
  margin-bottom: 10px;
}
.searchBox-minicart-opt button {
  width: 90%;
}
.searchBox-minicart-goods-name:hover,
.searchBox-minicart-total em {
  color: #e60012;
}
.searchBox-minicart-content{
  position: relative;
  display: flex;
  align-items: center;
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniCart/index.vue